import { Box, Container } from '@chakra-ui/react'
import type { BoxProps } from '@chakra-ui/react'

export type PageContainerProps = BoxProps & {
	children: React.ReactNode
}

const PageContainer = ({ children, ...boxProps }: PageContainerProps) => {
	return (
		<Box maxW="1440px" mx="auto" px={{ base: 6, md: 12, lg: 16 }} py={{ base: 4, md: 6, lg: 8 }} {...boxProps}>
			{children}
		</Box>
	)
}

export default PageContainer;